import PropTypes from 'prop-types';

export default PropTypes.shape({
    brandColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    textAndIconColor: PropTypes.string
})